<template>
  <div class="media-edit-page scrollable">
    <div class="page-header">
      <h1>{{ $route.meta.title }}</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'media' }">
          Media
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="edit-form">
      <el-form
          :model="formData"
          status-icon
          :rules="rulesValidate"
          ref="mediaEditForm"
          label-width="135px"
          class="demo-ruleForm"
      >
        <el-form-item label="Name" prop="name">
          <el-input
              type="text"
              v-model="formData.original_name"
              autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('mediaEditForm')"
          >Save
          </el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Message } from 'element-ui'

export default {
  name: 'MediaEdit',
  data () {
    return {
      urlRequest: '',
      formData: {
        id: '',
        original_name: '',
      },
      rulesValidate: {
        name: [{required: true, message: 'Please input Meidia name. Name unique', trigger: 'blur'}],
      },
    }
  },
  computed: {
    ...mapGetters({
      media: 'media/getMedia',
    }),
  },
  created () {
      this.$store.dispatch('media/getMedia', this.$route.params.id)
  },
  watch: {
    media(newMedia) {
      if (newMedia) {
        this.formData = newMedia
      }
    }
  },
  methods: {
    submitForm () {
        this.$store.dispatch('media/updateMedia', this.formData).then((resp) => {
          this.$router.push({name:"media"})
        })
    },
  },
}
</script>